import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const TaskHeader = ({ currentDate, previousMonth, nextMonth }) => {
  const monthNames = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December",
  ];

  return (
    <div className="bg-blue-400 p-3 text-white">
      <div className="flex items-center justify-between">
        <button
          onClick={previousMonth}
          className="p-2 hover:bg-white/20 rounded-lg transition"
        >
          <ChevronLeft size={28} />
        </button>
        <h1 className="text-xl font-medium">
          {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
        </h1>
        <button
          onClick={nextMonth}
          className="p-2 hover:bg-white/20 rounded-lg transition"
        >
          <ChevronRight size={28} />
        </button>
      </div>
    </div>
  );
};

export default TaskHeader;
